import React from "react";

import { Hotspot } from "../../../Types";
import { editorHotspotStore } from "../../../api/Zustand";
import { QuizAddIcon } from "../../Icons/left-side-bar-icons";
import { getLanguageFile } from "../../common/GetLanguageFile";

function Quiz({ spot }: { spot: Hotspot }) {
  const { openHotspot, setHotspotData } = editorHotspotStore();

  return (
    <div className="hotspot link">
      <QuizAddIcon
        color={spot.isNew ? "#ff8700" : "white"}
        width="3.5em"
        height="3.5em"
        stroke="#282828"
        strokeWidth="25px"
      />

      {spot.isNew ? (
        !spot.EDIT_POS && <p>{getLanguageFile("hotspots.unsaved")}</p>
      ) : spot.target ? (
        <p
          onClick={() => {
            openHotspot(true);
            setHotspotData(spot.target as string);
          }}
        >
          {getLanguageFile("hotspots.question")}
        </p>
      ) : (
        <p>{getLanguageFile("hotspots.missing_question")}</p>
      )}
    </div>
  );
}

export default Quiz;
